import React, { useState } from "react";
import { DeleteCategory } from "../../pages";
import BusinessCategoryController from "../../controllers/BusinessCategoryController";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";

const DeleteCategoryContainer = ({ closeModal, data }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async (id) => {
    setLoading(true);
    const { status, errorMessage } =
      await BusinessCategoryController.deleteBusinessCategories(id);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: constant.Success });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  const goBack = () => {
    closeModal();
  };
  return (
    <DeleteCategory
      loading={loading}
      handleDelete={handleDelete}
      closeModal={closeModal}
      goBack={goBack}
      data={data}
    />
  );
};
export default DeleteCategoryContainer;
